import { render, staticRenderFns } from "./Article1MobileAndroid.vue?vue&type=template&id=2c39f384&scoped=true&"
import script from "./Article1MobileAndroid.vue?vue&type=script&lang=js&"
export * from "./Article1MobileAndroid.vue?vue&type=script&lang=js&"
import style0 from "./Article1MobileAndroid.vue?vue&type=style&index=0&id=2c39f384&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c39f384",
  null
  
)

export default component.exports